export const getDisplayedDecimalsAmount = (value: number) => {
  const stringOfValue = String(Math.floor(value));
  if (stringOfValue.length <= 7) {
    return 2;
  }
  if (stringOfValue.length === 8) {
    return 1;
  }
  return 0;
};

export const getCurrencySymbol = (currencyCode: string, locale: string) =>
  (1)
    .toLocaleString(locale, {
      style: 'currency',
      currency: currencyCode,
      maximumSignificantDigits: 1,
      currencyDisplay: 'symbol',
    })
    .replace('1', '')
    .trim();
